module.exports = __webpack_public_path__ + "img/coupon_tutorial_ROMAPI04.794fc984.jpg";